import Splide from "@splidejs/splide";

function initCarousel() {
    new Splide(".js-carousel", {
        snap: !0,
        perPage: 3,
        focus: "left",
        lazyLoad: "nearby",
        pagination: !1,
        gap: "1rem",
        breakpoints: {960: {perPage: 2}, 640: {perPage: 1}}
    }).mount()
}

document.getElementsByClassName("js-carousel")[0] && initCarousel();